import { render, staticRenderFns } from "./image-tint.vue?vue&type=template&id=b445cace&scoped=true"
import script from "./image-tint.vue?vue&type=script&lang=js"
export * from "./image-tint.vue?vue&type=script&lang=js"
import style0 from "./image-tint.vue?vue&type=style&index=0&id=b445cace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b445cace",
  null
  
)

export default component.exports